<template>
	<div id="product-list-area">
		<div class="func-bar" v-if="selectedType != null">
			<!-- 面包屑 -->
			<div class="center-common-breadcrumb">
				<span>{{ cur_lang == "zh" ? selectedType.nameCh : selectedType.nameEn }}</span>
				<span style="width: 20px; text-align: center;">/</span>
				<span>{{ cur_lang == "zh" ? "详情介绍" : "Product introduction" }}</span>
			</div>

		</div>
		<!-- 产品介绍 -->
		<div class="product-content"
			style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
			<div id="content" style="width: 96%;"></div>
		</div>
		
		<!-- 型号列表头 -->
		<div class="func-bar" v-if="selectedType != null">
			<div style="background-color: #163E87; color: white; padding: 5px; margin-left: 15px; border-radius: 3px;" v-if="selectedType != null">
				<span>{{ cur_lang == "zh" ? "型号列表" : "Model List" }}</span>
			</div>
			
			<div class="search"
				style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
			
				<span style="width: 80px;">
					{{ $t("search_center.use") }}:
				</span>
				<div class="edit-purpose-select">
					<el-select v-model="selectedTag" :placeholder="($t('search_center.select_tag'))"
						@change="selecteTagsTemplate" clearable>
						<el-option v-for="item in tagsTemplates" :key="item.id"
							:label="(cur_lang == 'zh' ? item.nameCh : item.nameEn)" :value="item.id">
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
		
		<!-- 产品型号 -->
		<div class="model-content" v-loading="loading" element-loading-text="加载中...">
			<div class="model" placement="top"
				:style="{marginLeft: modelMarginLeft + 'px', marginBottom: modelMarginLeft + 'px'}"
				v-for="(item, index) in productModels" @click="lookupProductModelInfo(item)" :key="index"
				:title="cur_lang == 'zh' ? item.synopsisCh : item.synopsisEn">

				<el-image class="model-image" :src="imageBaseURL + item.materialUrl + '?reduce=true'" fit="contain">
				</el-image>
				<div class="model-name">{{ item.model }}</div>

			</div>
			
		</div>

		<div v-if="is_no_data" style="width: 100%; text-align: center; line-height: 100px;">
			{{ $t("nodata") }}
		</div>
		<!-- 分页 -->
		<div style="margin-top: 15px; margin-bottom: 15px; width: 100%; height: 60px; display: flex; flex-direction: column; justify-content: center; align-items: center;"
			v-if="total != 0">
			<el-pagination background @current-change="handleCurrentChange" layout="prev, pager, next"
				:total="total" :page-size="pageSize" :current-page="parseInt(currentPage)">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		name: "ProductList",
		data() {
			return {
				cur_lang: "zh",
				searchText: "",
				selected_type_index: 0,
				selected_type_sub_index: 0,
				selectedType: null,
				
				total: 0,
				pageSize: 15,
				currentPage: 1,

				// 产品型号
				products: [],
				modelMargin: 0,
				
				loading: false,
				
				product_id: '',
				
				modelMarginLeft: 0,
				
				productModels: [],
				is_no_data: false,
				
				tagsTemplates: [],
				selectedTag: '',
			};
		},

		created() {
			let cur_lang = localStorage.getItem("locale");
			if (cur_lang) {
				this.cur_lang = cur_lang
			}

			// 获取链接
			// 通过复制链接，本地没有缓存
			// 获取链接从?号开始的参数,如:  ?a=1&b=2
			let url = location.search;
			// 去除问号
			let str = url.substr(1);
			// 分离参数
			let strArray = str.split("&");
			// 解码参数，获取信息
			this.selected_type_index = decodeURIComponent(strArray[0].replace("type_index=", ""));
			this.selected_type_sub_index = decodeURIComponent(strArray[1].replace("type_sub_index=", ""));

			this.getCurSubType();
		},

		mounted() {
			this.modelMargin = (1200 - 230 - 200 * 4.0) / 5.0;
			
			this.modelMarginLeft = (1200 - 230 - 10 - 130 * 6) / 7.0;
			
			// 监听到获取完所有类型
			this.showIntro();

			const that = this;
			window.addEventListener("setItem", function(e) {
				// console.log('product 监听到了~', e.key);
				if (e.key == 'locale') {
					// 监听切换中英
					that.cur_lang = e.newValue;
					that.showIntro();

				} else if (e.key == 'all_product_type_list') {
					// 监听到获取完所有类型
					
					// 点击了菜单栏的类目，当前页重置为1
					that.currentPage = 1
					// 找到 cur_sub_type
					that.getCurSubType();
					that.showIntro();
				} else if (e.key == 'is_update_second_type') {
					
					let infoArray = e.newValue.split('-');
					that.selected_type_index = infoArray[0];
					that.selected_type_sub_index = infoArray[1];
					// 点击了菜单栏的类目，当前页重置为1
					that.currentPage = 1
					// 找到 cur_sub_type
					that.getCurSubType();
					that.showIntro();
				}
			});
		},

		methods: {

			getCurSubType: function() {

				let typesJson = sessionStorage.getItem('all_product_type_list');
				if (typesJson == null) {
					console.log('typesJson 为空')
					return
				};

				let types = JSON.parse(typesJson);
				if (types.length == 0) {
					console.log('types length 为 0')
					return
				};

				// 根据下标找到对应的一级大类
				let type = types[this.selected_type_index];
				if (type.child.length == 0) {
					console.log('type child length 为 0')
					return
				};

				// 根据下标找到对应的二级分类
				this.selectedType = type.child[this.selected_type_sub_index];
				// 获取产品
				// this.getTypeProduct();
				this.getProductModel()
				this.getProductModelTag()
			},

			showIntro: function() {

				this.getCurSubType();

				// console.log('selectedType: ', this.selectedType);
				if (this.selectedType == null) return;

				let t = document.getElementById("content");
				if (t != null) {
					// 重点：将字符串解析成html进行展示
					t.innerHTML = this.cur_lang == "zh" ? this.selectedType.articleCh : this.selectedType.articleEn;
				}
			},

			// 获取某类型下的产品, 只有一个
			getTypeProduct: function() {

				if (this.selectedType == null) return;
				if (typeof this.selectedType.id == "undefined") return;

				let url =
					"admin/getProduct?columnId=" +
					this.selectedType.id +
					"&page=1" 
					// + this.currentPage;
				let that = this;
				this.$utils.httpRequestGet(
					url,
					null,
					function success(res) {
						// console.log('获取产品', res.data.data);
						that.products = res.data.data;
						if (that.products.length) {
							that.product_id = that.products[0].id;
							that.getProductModel()
						}
					},
					function fail(res) {
						console.log("产品类型请求失败", res);
					}
				);
			},

			
			// 获取产品型号
			getProductModel: function() {
				let that = this;
				// 显示加载
				this.loading = true;
				// this.selectedType.id 二级分类id
				let url = "api/product/getModel?id=" + this.selectedType.id + '&page=' + this.currentPage + '&limit=' + this.pageSize;
				
				if (this.selectedTag.length || this.selectedTag > 0) {
					url += '&tagId=' + this.selectedTag
				}
			
				this.$utils.httpRequestGet(
					url,
					null,
					function success(res) {
						// 隐藏加载
						that.loading = false;
						// 赋值
						that.productModels = res.datas;
						// that.totalPage = res.data.totalPage;
						that.total = res.count;
			
						that.is_no_data = false;
						if (that.productModels.length == 0) {
							that.is_no_data = true;
						}
					},
					function fail(res) {
			
						// 隐藏加载
						that.loading = false;
						that.is_no_data = true;
						console.log("产品型号请求失败", res);
					}
				);
			},
			
			// 获取该产品下型号所用的标签
			getProductModelTag: function(){
				if (this.selectedType == null) return;
				if (typeof this.selectedType.id == "undefined") return;
				
				// 二级分类id productTwoId
				let url =
					"api/main/getTag?productTwoId=" +
					this.selectedType.id 
				let that = this;
				this.$utils.httpRequestGet(
					url,
					null,
					function success(res) {
						that.tagsTemplates = res.datas;
					},
					function fail(res) {
						console.log("产品类型请求失败", res);
					}
				);
			},
			
			
			lookupProductModelInfo: function(model) {
			
				sessionStorage.setItem('cur_model_page', this.currentPage);
			
				let type_index = 'type_index=' + this.selected_type_index;
				let type_sub_index = '&type_sub_index=' + this.selected_type_sub_index;
				let product_id = '&product_id=' + this.product_id;
				let model_id = '&model_id=' + model.id;
			
				window.location.href = 'productcentermodelinfo.html?' + type_index  + type_sub_index + product_id + model_id;
			},
			
			selecteTagsTemplate: function(tagId) {
				// console.log('tagId: ', tagId)
				this.getProductModel();
			},
			
			
			// 页面变化
			handleCurrentChange: function(val) {
				// console.log(`当前页: ${val}`);
				this.currentPage = val;
				// 获取当前页
				this.getProductModel();
			}
		}
	};
</script>

<style>
	#product-list-area {
		width: 100%;
	}

	.func-bar {
		width: 100%;
		min-height: 50px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #cccccc;
	}

	.center-common-breadcrumb {
		width: 65%;
		height: 100%;
		font-size: 18px;
		margin-left: 10px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.product-style {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		/* 自动换行 */
		flex-wrap: wrap;
	}

	.product-style .product-item {
		width: 200px;
		height: 240px;
		background-color: #ffff;
		margin-top: 15px;
		/* border: 1px solid #2C3E50; */

		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.product-item .product-image {
		width: 198px;
		height: 198px;
		cursor: pointer;
		border-left: 1px solid #ccc;
		border-top: 1px solid #ccc;
		border-right: 1px solid #ccc;
	}

	.product-item .product-name {
		width: 198px;
		line-height: 38px;
		border: 1px solid #ccc;
		text-align: center;
		color: #2c3e50;
		/* 文字过长显示省略号 */
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.product-item:hover .product-name {
		background-color: #163e87;
		color: #fff;
	}
	
	
	.func-bar .center-common-breadcrumb {
		width: 65%;
		height: 100%;
		font-size: 18px;
		margin-left: 10px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	
	.func-bar .search {
		width: 30%;
	}
	
	.model-content {
		margin-top: 15px;
		width: 100%;
		min-height: 100px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		/* background-color: #163E87; */
	}
	
	.model-content .model {
		width: 150px;
		height: 180px;
		color: white;
		border-radius: 5px;
		box-shadow: 0px 2px 2px #cccccc;
		word-break: break-word;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	
		border: 1px solid #ccc;
	}
	
	.model-content .model:hover {
		transition: all 0.25s;
		transform: scale(1.02);
	}
	
	.model .model-image {
		width: 150px;
		height: 150px;
	}
	
	.model .model-name {
		width: 150px;
		line-height: 30px;
		font-size: 14px;
		color: #2c3e50;
	
		border-bottom-right-radius: 5px;
		border-bottom-left-radius: 5px;
	
		/* 文本不换行，这样超出一行的部分被截取，显示... */
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.model:hover .model-name {
		color: #FFF;
		background-color: #163E87;
	}
</style>
